import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import {
  clearMapDrawFeatures,
  selectCurrMapDrawFeatures,
} from '../../onboardingSlice';
import { valXYAndCreateFeatureCollection } from '../../onboardingUtils';
import SubmitSnackbar from '../components/SubmitSnackBar';
import { useGetCurrOnboardBlock } from '../hooks/useGetCurrOnboardBlock';
import OrientationFormTabActionSection from './OrientationFormTabActionSection';
import OrientationFormTabDiagramSection from './OrientationFormTabDiagramSection';
import useSubmitBlockMapItem from './hooks/useSubmitBlockMapItem';

const OrientationFormTab: React.FC = () => {
  const dispatch = useAppDispatch();
  const currMapDrawFeatures = useAppSelector(selectCurrMapDrawFeatures);

  const {
    blockSubmitHandler,
    snackbarOpen,
    setSnackbarOpen,
    errorMessage,
    setErrorMessage,
  } = useSubmitBlockMapItem();

  const { currentData: block } = useGetCurrOnboardBlock();

  // Reset the status when the block changes
  useEffect(() => {
    setErrorMessage('');
    setSnackbarOpen(false);
  }, [block]);

  const handleSendOrientationClick = async () => {
    setErrorMessage('');
    setSnackbarOpen(false);

    if (!block) {
      setErrorMessage('No block found');
      setSnackbarOpen(true);
      return;
    }

    const validatedFeatureCollection =
      valXYAndCreateFeatureCollection(currMapDrawFeatures);

    if (
      validatedFeatureCollection.error ||
      !validatedFeatureCollection.featureCollection
    ) {
      setErrorMessage('Invalid vectors.');
      setSnackbarOpen(true);
      return;
    }

    try {
      await blockSubmitHandler({
        ...block,
        geoOrientation: validatedFeatureCollection.featureCollection,
      });

      dispatch(clearMapDrawFeatures());
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  const isSubmitDisabled = useMemo(() => {
    return valXYAndCreateFeatureCollection(currMapDrawFeatures).error;
  }, [currMapDrawFeatures]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'min-content 1fr',
        gridTemplateRows: '1fr',
        gap: '1rem',
      }}
    >
      <SubmitSnackbar snackbarOpen={snackbarOpen} errorMessage={errorMessage} />
      <OrientationFormTabDiagramSection />
      <OrientationFormTabActionSection
        handleSendOrientationClick={handleSendOrientationClick}
        isSubmitDisabled={isSubmitDisabled}
      />
    </Box>
  );
};

export default OrientationFormTab;
